export const OPEN_ACTION_DIALOG = '@@appDialog/OPEN_ACTION_DIALOG';
export const CLOSE_ACTION_DIALOG = '@@appDialog/CLOSE_ACTION_DIALOG';

export const CHANGE_ROLE_IN_ORGANIZATION = 'CHANGE_ROLE_IN_ORGANIZATION';
export const REMOVE_USER_FROM_ORGANIZATION = 'REMOVE_USER_FROM_ORGANIZATION';
export const CHANGE_ROLE_IN_BUCKET = 'CHANGE_ROLE_IN_BUCKET';
export const REMOVE_USER_FROM_BUCKET = 'REMOVE_USER_FROM_BUCKET';
export const ADD_USERS_TO_BUCKETS = 'ADD_USERS_TO_BUCKETS';



// WEBPACK FOOTER //
// ./src/constants/appDialog.js